import { useEffect,useState } from 'react'
import { useSelector } from 'react-redux'
import { useHistory,useLocation } from 'react-router-dom'

import queryString from 'query-string'

import { getCurrentUserField } from '../selectors'

const notificationSettingsHash = 'notificationSettings'
const savedFilterIdHash = 'savedFilterId'

export default function useNotificationSettingsModal() {
  const location = useLocation()
  const history = useHistory()
  const { hash, search } = location

  const hashParams = queryString.parse(hash)
  const searchParams = queryString.parse(search)
  const [modalOpen, setModalOpen] = useState<boolean>(false)
  const currentUserId = useSelector<any, number | undefined>(getCurrentUserField('id'))
  const savedFilterIdParam = parseInt(String(searchParams[savedFilterIdHash]) || '')
  const shouldDefaultOpenNotificationSettings =
    notificationSettingsHash in hashParams && Boolean(currentUserId)

  useEffect(() => {
    setModalOpen(shouldDefaultOpenNotificationSettings)
  }, [shouldDefaultOpenNotificationSettings, hashParams])

  const onModalClose = () => {
    history.push({ search: search, hash: 'updatedNotificationSettings' })
    setModalOpen(false)
  }

  return { modalOpen, savedFilterIdParam, onModalClose }
}
